import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
} from '@mui/material';
import React from 'react';

import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

interface TabPanelProps {
  children?: React.ReactNode;
  index?: number;
  value?: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`faqs-content-${index}`}
      aria-labelledby={`faqs-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ px: 1, pt: 2 }}>{children}</Box>}
    </div>
  );
}

// function a11yProps(index: number) {
//   return {
//     id: `faqs-${index}`,
//     'aria-controls': `faqs-${index}`,
//   };
// }

const FAQs = () => {
  const [value, setValue] = React.useState(10);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <AppLayout
      meta={
        <Meta
          title="Form 8868 e-Filing FAQs | Simplify Filing with TaxZerone®"
          description="Utilize TaxZerone's Knowledge Base and Frequently Asked Questions (FAQ) to facilitate the smooth e-filing of IRS Form 8868."
          keywords=""
          canonical="faqs/form-8868/"
        />
      }
    >
      <Container maxWidth="md">
        <Stack
          direction={{ xs: 'column', md: 'column' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0, textAlign: 'center' }, py: 3 }}
        >
          <Box
            component="div"
            sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                fontWeight: 600,
                color: '#374151',
                mb: 3,
              }}
            >
              <span className="highlight-container">
                <span className="highlight">FAQs - Form 8868</span>
              </span>{' '}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
              }}
              id="general"
            >
              Here are some common questions you may have about Form 8868
            </Typography>
          </Box>
        </Stack>
      </Container>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',

          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={0}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5, px: 0 }}>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems="flex-start"
            spacing={2}
          >
            <Hidden smDown>
              <Box
                sx={{
                  maxWidth: 180,
                  position: 'sticky',
                  top: 90,
                  border: '1px solid #ccc',
                  mt: '24px !important',
                  borderRadius: 2,
                  boxShadow: '0 0 10px rgba(0,0,0,.10)',
                  backgroundColor: 'rgba(255, 255, 255, 0.85)',
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  orientation="vertical"
                  aria-label="faqs"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    py: 1,
                  }}
                  className="faq-container"
                >
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          General
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      //  color: '#ccc',
                    }}
                    href="/faqs/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 2290
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-2290/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{
                              width: 12,
                              height: 12,
                              marginRight: 4,
                              marginTop: 3,
                            }}
                          />
                          Form 2290 Amendments
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-2290-amendments/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 8849
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-8849/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990-EZ
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990-ez/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 990-N
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-990-n/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 941
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-941/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 7004
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-7004/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 4868
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-4868/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 8868
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-8868/"
                  />
                  <Tab
                    label={
                      <React.Fragment>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <img
                            src="/assets/images/bullet-arrow.png"
                            alt="arrow"
                            style={{ width: 12, height: 12, marginRight: 4 }}
                          />
                          Form 15397
                        </Box>
                      </React.Fragment>
                    }
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                    }}
                    href="/faqs/form-15397/"
                  />
                </Tabs>
              </Box>
            </Hidden>
            <Hidden smUp>
              <Box
                sx={{
                  position: 'sticky',
                  top: 62,
                  backgroundColor: '#213e99',
                  zIndex: 1,
                  width: '100%',
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  variant="scrollable"
                  scrollButtons
                  allowScrollButtonsMobile
                  aria-label="faqs"
                  sx={{
                    textAlign: 'center',
                    justifyContent: 'center',
                    '& .MuiSvgIcon-root': { fill: '#fff' },
                    maxWidth: 380,
                    mt: '2px',
                  }}
                  className="faq-container"
                >
                  <Tab
                    label="General"
                    // {...a11yProps(0)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/"
                  />
                  <Tab
                    label="Form 2290"
                    //  {...a11yProps(1)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-2290/"
                  />
                  <Tab
                    label="Form 2290 Amendments"
                    //  {...a11yProps(2)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-2290-amendments/"
                  />
                  <Tab
                    label="Form 8849"
                    //  {...a11yProps(3)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-8849/"
                  />
                  <Tab
                    label="Form 990"
                    //  {...a11yProps(4)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-990/"
                  />
                  <Tab
                    label="Form 990-N"
                    //  {...a11yProps(4)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-990-n/"
                  />
                  <Tab
                    label="Form 7004"
                    //  {...a11yProps(5)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-7004/"
                  />
                  <Tab
                    label="Form 4868"
                    //  {...a11yProps(6)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-4868/"
                  />
                  <Tab
                    label="Form 8868"
                    //  {...a11yProps(7)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-8868/"
                  />
                  <Tab
                    label="Form 15397"
                    //  {...a11yProps(8)}
                    sx={{
                      textTransform: 'none',
                      fontSize: { xs: 12, sm: 14, md: 16 },
                      color: '#ccc',
                    }}
                    href="/faqs/form-15397/"
                  />
                </Tabs>
                <Box sx={{ borderBottom: 0, borderColor: 'divider' }} />
              </Box>{' '}
            </Hidden>
            <Box
              sx={{
                width: '100%',
                pt: { sm: '8px !important' },
                px: { xs: 2, sm: 0 },
              }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <TabPanel>
                {/* <Typography
                  variant="h2"
                  sx={{
                    fontSize: { xs: 18, sm: 20, md: 24, lg: 30 },
                    fontWeight: 600,
                  }}
                >
                  Form 8868
                </Typography> */}
                <Grid container spacing={0} rowSpacing={2} m={0} mt={0}>
                  <Grid size={12} sx={{ pt: '0 !important' }}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        Who should file Form 8868?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Box itemProp="text">
                          <Typography variant="body1" sx={{ mb: 2 }}>
                            <Link
                              href="/resources/tax-extension/form-8868-instructions/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 8868
                            </Link>
                            , Application for Automatic Extension of Time to
                            File an Exempt Organization Return, is filed by
                            tax-exempt organizations, including charities,
                            nonprofits, and certain other exempt entities that
                            need extra time to complete and submit their annual
                            tax returns. By filing Form 8868, organizations will
                            get an{' '}
                            <span style={{ fontWeight: 600 }}>
                              {' '}
                              extension
                            </span>{' '}
                            of up to <br />{' '}
                            <span style={{ fontWeight: 600 }}>6 months</span> to
                            file their annual return.
                          </Typography>
                          <Alert severity="warning" icon={false}>
                            <b>Note:</b> Form 8868 cannot be used to extend the
                            due date of Form 990-N.
                          </Alert>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        When is the deadline for filing Form 8868?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography variant="body1" itemProp="text">
                          For organizations that follow a fiscal tax year, Form
                          8868 must be filed by the{' '}
                          <span style={{ fontWeight: 600 }}>
                            15th day of the 5th month
                          </span>{' '}
                          after your tax year ends. In the event that the due
                          date falls on a weekend or a federal holiday, the
                          deadline for filing will be the following business
                          day.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        Can I file Form 8868 electronically?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography variant="body1" itemProp="text">
                          <span style={{ fontWeight: 600 }}> Yes</span>, you can
                          <Link
                            href="/tax-extension/efile-irs-form-8868-exempt-organization-tax-extension-online/"
                            sx={{ color: '#0202ff' }}
                          >
                            {' '}
                            file Form 8868{' '}
                          </Link>
                          electronically through TaxZerone. It is an
                          IRS-authorized e-file provider, allowing you to
                          request an automatic{' '}
                          <span style={{ fontWeight: 600 }}>
                            6-month extension
                          </span>{' '}
                          for{' '}
                          <Link href="/tax-exempt/" sx={{ color: '#0202ff' }}>
                            exempt organization
                          </Link>{' '}
                          returns.
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What happens if I miss the deadline for filing Form
                        8868?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography variant="body1" itemProp="text">
                          If you miss the deadline to file Form 8868 , you will
                          not get an{' '}
                          <span style={{ fontWeight: 600 }}>
                            automatic 6-month extension
                          </span>{' '}
                          to file your return. Your return may be considered
                          late, and your organization could face daily
                          penalties. Repeated late filings can even lead to{' '}
                          <span style={{ fontWeight: 600 }}>
                            loss of tax-exempt status
                          </span>
                          .
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        What information is required to file Form 8868?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Typography
                          component="div"
                          variant="body1"
                          sx={{ mb: 2 }}
                          itemProp="text"
                        >
                          <ul>
                            <li>
                              Exempt organization or filer information such as
                              name and address.
                            </li>
                            <li>Organization&apos;s tax year</li>
                            <li>Taxpayer identification number (TIN)</li>
                            <li>
                              Return code of the application for which the
                              organization needs to file an extension form
                            </li>
                            <li>
                              Group exemption number (GEN) if filing an
                              extension for a group return.
                            </li>
                            <li>Tentative total tax</li>
                            <li>Total payments and credits</li>
                          </ul>
                        </Typography>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid size={12}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 2 }}
                      itemScope
                      itemProp="mainEntity"
                      itemType="https://schema.org/Question"
                    >
                      <Typography
                        variant="h2"
                        sx={{
                          fontWeight: 600,
                          color: '#36324a',
                          fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                          mb: 1,
                        }}
                        itemProp="name"
                      >
                        How do I know if the IRS accepted my extension form
                        8868?
                      </Typography>
                      <Box
                        itemScope
                        itemProp="acceptedAnswer"
                        itemType="https://schema.org/Answer"
                      >
                        <Box itemProp="text">
                          <Typography variant="body1" sx={{ mb: 2 }}>
                            When you file Form 8868 with TaxZerone, you will be
                            notified about the filing status, and whether the
                            IRS has accepted or rejected your return.
                          </Typography>
                          <Typography variant="body1">
                            If your return is rejected by the IRS, you can
                            correct the errors and retransmit it to the IRS for{' '}
                            <b>FREE</b>.
                          </Typography>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </TabPanel>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
          }}
        >
          Ready to simplify your complex tax filing process?
        </Typography>

        <Typography
          variant="h3"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
          }}
        >
          Choose TaxZerone and file IRS tax forms online in easy steps.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=faqs`}
          >
            E-file Now
          </Button>
        </Box>
      </Box>
    </AppLayout>
  );
};

export default FAQs;
